import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LanguageSelectorComponent } from './language-selector.component';

@NgModule({
  imports: [CommonModule, TranslateModule, LanguageSelectorComponent],
  declarations: [],
  exports: [LanguageSelectorComponent],
})
export class I18nModule {}
